import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { cmoMembersList } from '../../../../containers/actions/pharmaCo/purchaseOrderActions';
import { makeStyles } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
    pad: {
        padding: '12px'
    },
    selectMenu: {
        minWidth: 120,
    },
}));

const CMOFilter = (props) => {
  const { handleSelectCMO, CMOMember } = props;
  const classes = useStyles();
  const dispatch = useDispatch();

  let cmoMembers = useSelector((state) =>
    state.pcmp.pharmaCo.purchaseOrder.cmoMemberWithId
      ? state.pcmp.pharmaCo.purchaseOrder.cmoMemberWithId
      : []
  );

  useEffect(() => {
    dispatch(
      cmoMembersList({
          collabType: localStorage.collabType,
          roleName: localStorage.roleName,
          organizationName: localStorage.organizationName,
          ecosystemId: localStorage.ecosystemId
        // collabType: 'Pharma Co',
        // roleName: 'Admin',
        // organizationName: 'Lupin',
        // ecosystemId: 1,
      })
    );
  }, [dispatch]);

  return (
    <FormControl fullWidth className={classes.selectMenu} >
      {/* <InputLabel id='demo-simple-select-label'>CMO</InputLabel> */}
          <Select
              disabled
        labelId='cmo-filter'
        id='cmo-filter-id'
        value={CMOMember}
        onChange={handleSelectCMO}
              variant='outlined'
        // classes={{
        //     outlined: classes.outlined,
              // }}
              classes={{ root: classes.pad }}
      >
        <MenuItem value={0}>All</MenuItem>
        {cmoMembers.map((cmoMember, i) => (
          <MenuItem key={i} value={cmoMember.organizationId} disabled={cmoMember === null ? true : false}>
            {cmoMember.organizationName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CMOFilter;
